export const formatLicensePlate = (plate) => {
  if (!plate || typeof plate !== 'string') return plate;
  
  const cleanPlate = plate.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
  
  if (cleanPlate.length === 7) {
    return cleanPlate.slice(0, 3) + '-' + cleanPlate.slice(3);
  }
  
  return cleanPlate;
};